import { DataSource } from "@seriously-rad/seriouslyrad-framework-core/Data/DataSource";
import { IJNativeEvent } from "@seriously-rad/seriouslyrad-framework-core/JNative";
import { LinqArray } from "@seriously-rad/seriouslyrad-framework-core/LinqArray";
import { ClassPropertyDialog } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ClassPropertyDialog";
import { ComboBox } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ComboBox";
import { ReportElement } from "./ReportElement";

export class ComboBoxReportStoredProcedureProperties extends ComboBox
{
    // #region Public Methods

    public async loadDataAsync()
    {
        const
            page = this.page.get();

        if (!(page instanceof ClassPropertyDialog))
            return;

        if (!(page.instance instanceof ReportElement))
            return;

        const
            reportTemplate = page.instance._getReportTemplate();

        if (!reportTemplate)
            return;

        this.listDataSource.set(
            new DataSource({
                data:
                    LinqArray.create(reportTemplate.storedProcedureProperties.get() ?? [])
                        .orderBy(item => item.name)
                        .map(item => ({ description: item.name, value: item.name, propertyTypeId: item.propertyTypeId }))
            })
        );
    }

    // #endregion

    // #region Overrides

    protected override onChange(evt: IJNativeEvent)
    {
        super.onChange(evt);

        const
            self = evt.data.self as this,
            dataSource = self.dataSource.get();

        dataSource?.propertyValueByPathSet("templateProperties.dataSourceFieldTypeId", self.selectedItem.get()?.propertyTypeId ?? null);
    }

    // #endregion
}